/*
*/
import React from 'react';
import Modal from 'react-bootstrap/Modal';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        // top: `${top}%`,
        // left: `${left}%`,
        // transform: `translate(-${top}%, -${left}%)`,
    }
}

export interface IModalProps {
    open: boolean,
    title?:string,
    className?:string,
    closeButton?:boolean | true,
    backdrop?:"static"|true|false,
    keyboard?:boolean | false,
    onClose?: () => void,
    onShow?: () => void,
    onPasswordResetClicked?: () => void,
    children?: JSX.Element,
}

export default function ModalBox(props: IModalProps): JSX.Element {
   // const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);

    return (
				<Modal onShow={props.onShow} show={props.open} onHide={props.onClose} dialogClassName={props.className} backdrop={props.backdrop} keyboard={props.keyboard}>
        	<Modal.Header closeButton={props.closeButton}>
        		 <Modal.Title>{props.title}</Modal.Title>
        	</Modal.Header>
        	<Modal.Body>
            <div style={modalStyle}>
                {props.children}
            </div>
        	</Modal.Body>
        </Modal>
    );
}